import { defineComponent, computed, watchEffect, createBlock, createCommentVNode, unref, openBlock, withCtx, resolveDynamicComponent } from "vue";
import { isFilled } from "@prismicio/client";
import { asTree } from "@prismicio/client/richtext";
import { DEV } from "esm-env";
import _sfc_main$1 from "../lib/Wrapper.vue.js";
import { usePrismic } from "../usePrismic.js";
import _sfc_main$3 from "./DeprecatedPrismicRichText.vue.js";
import _sfc_main$2 from "./PrismicRichTextSerialize.vue.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{ name: "PrismicRichText" },
  __name: "PrismicRichText",
  props: {
    field: {
      type: Array
    },
    fallback: {
      type: [String, Object, Function]
    },
    components: {
      type: Object
    },
    linkResolver: {
      type: Function
    },
    serializer: {
      type: [Object, Function]
    },
    wrapper: {
      type: [String, Object, Function]
    }
  },
  setup(__props) {
    const props = __props;
    const { options } = usePrismic();
    const resolvedComponents = computed(() => {
      var _a;
      return props.components || ((_a = options.components) == null ? void 0 : _a.richTextComponents);
    });
    const resolvedLinkResolver = computed(() => {
      return props.linkResolver || options.linkResolver;
    });
    const children = computed(() => {
      return asTree(props.field || []).children;
    });
    const isModern = computed(() => {
      var _a;
      if (props.components) {
        return true;
      }
      if (props.serializer) {
        return false;
      }
      if ((_a = options.components) == null ? void 0 : _a.richTextComponents) {
        return true;
      }
      if (options.richTextSerializer) {
        return false;
      }
      return true;
    });
    if (DEV) {
      watchEffect(() => {
        if (props.components && props.serializer) {
          console.warn(
            `[PrismicRichText] Only one of "components" or "serializer" (deprecated) props can be provided. You can resolve this warning by removing either the "components" or "serializer" prop. "components" will be used in this case.`
          );
        }
      });
    }
    return (_ctx, _cache) => {
      return isModern.value && (unref(isFilled).richText(__props.field) || __props.fallback) ? (openBlock(), createBlock(_sfc_main$1, {
        key: 0,
        wrapper: __props.wrapper
      }, {
        default: withCtx(() => [
          children.value.length ? (openBlock(), createBlock(_sfc_main$2, {
            key: 0,
            children: children.value,
            components: resolvedComponents.value,
            "link-resolver": resolvedLinkResolver.value
          }, null, 8, ["children", "components", "link-resolver"])) : (openBlock(), createBlock(resolveDynamicComponent(__props.fallback), { key: 1 }))
        ]),
        _: 1
      }, 8, ["wrapper"])) : !isModern.value ? (openBlock(), createBlock(_sfc_main$3, {
        key: 1,
        field: __props.field,
        fallback: typeof __props.fallback === "string" ? __props.fallback : void 0,
        "link-resolver": __props.linkResolver,
        serializer: __props.serializer,
        wrapper: __props.wrapper
      }, null, 8, ["field", "fallback", "link-resolver", "serializer", "wrapper"])) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=PrismicRichText.vue.js.map
